<template>
<div class="Sales">
  <vue-page-transition name="fade-in-down">
    <v-content class="db-content">
      <v-container fluid grid-list-xl class="useroptions">
        <sequential-entrance fromTop>
          <v-layout row wrap>
            <v-flex xs12 sm12 lg12 x12 class="lg5-custom">

            <v-card class="user-ui" style="padding: 15px">
              <v-avatar size="50px" tile>
                <img alt="Avatar" :src="userInfo.wt.SJ" />
              </v-avatar>
              <label class="headline" style="margin-left: 20px">
                {{ userInfo.wt.Ad }}
              </label>

                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  elevation="10"
                  :max-width="300"
                  min-height="130"
                >
                  <template v-slot:activator="{ off }">
                    <div v-on="on" class="three-dot">
                      <v-toolbar-title>Sales</v-toolbar-title>
                      <v-spacer></v-spacer>
                    </div>
                  </template>
                </v-menu>
              </v-card>
            </v-flex>
          </v-layout>
        </sequential-entrance>

        <v-layout row wrap>
          <v-flex xs12 sm12 md12 xl2 class="space3"> </v-flex>
        </v-layout>

        <v-flex class="space2" />

        <v-flex class="space2" />



            <sequential-entrance fromRight>

          <div class="navigate" >
          <v-container >
            <v-layout row wrap>
               <v-flex
              sm6
              xs6
              md6
              lg6
            >

              <v-btn class="ma-2" outlined color="teal" value="Go Back From Whence You Came!" onclick="history.back(-1)">Previous Page</v-btn>


               </v-flex>
               <v-flex
              sm6
              xs6
              md6
              lg6
            >
              <SalesPopup class="ma-2" outlined color="teal" onclick="" style="float: right;" />

               </v-flex>
            </v-layout>
          </v-container>
        </div>

        <div class="team" >
          <v-container >
            <v-layout row wrap>
               <v-flex
              sm6
              xs12
              md12
              lg4
            >
             <v-card class="theme-bg-card-warning" >

                <SalesGrade class="m-left" />


            </v-card>


               </v-flex>
                         <v-flex
                        sm6
                        xs12
                        md12
                        lg4
                      >
                       <v-card class="theme-bg-card-2" >

                          <salesInfo class="m-left" />

                      </v-card>


                         </v-flex>



                         <v-flex
                        sm6
                        xs12
                        md12
                        lg4
                      >
                       <v-card class="theme-bg-card-2" >

                      <sequential-entrance fromBottom>

                        <v-flex class="spacer"></v-flex>
                        <v-flex class="spacer"></v-flex>

                                 <salesProgressBar class="m-center" />

                        <v-flex class="spacer"></v-flex>
                        <v-flex class="spacer"></v-flex>
                      </sequential-entrance>


                      </v-card>


                         </v-flex>

                         <v-flex
                        sm6
                        xs12
                        md12
                        lg4
                      >
                       <v-card class="theme-bg-card-2" >

                          <Pipeline class="m-left" />


                      </v-card>


                         </v-flex>
                         <v-flex
                        sm6
                        xs12
                        md12
                        lg4
                      >
                       <v-card class="theme-bg-card-2" >

                          <Quotes class="m-left" />

                      </v-card>


                         </v-flex>



                         <v-flex
                        sm6
                        xs12
                        md12
                        lg4
                      >
                       <v-card class="theme-bg-card-2" >
                          <Invoices class="m-left" />
                      </v-card>


                         </v-flex>

                         <v-flex
                        sm6
                        xs12
                        md12
                        lg4
                      >
                       <v-card class="theme-bg-card-2" >


                          <LineBar class="m-left" />



                  <v-spacer></v-spacer>



                  </v-card>
                      </v-flex>
                <v-flex
                        sm6
                        xs12
                        md12
                        lg4
                      >
                       <v-card class="theme-bg-card-2" >



                          <LineChart class="m-left" />


                  <v-spacer></v-spacer>


                  </v-card>
                      </v-flex>

                         <v-flex
                        sm6
                        xs12
                        md12
                        lg4
                      >
                       <v-card class="theme-bg-card-2" >
                          <Bar class="m-left" />
                      </v-card>


                         </v-flex>

                      </v-layout>
                    </v-container>
                  </div>


                       <v-layout row wrap>
                        <v-flex xs12 sm12 md12 xl2 class="space2">

                        </v-flex>
                      </v-layout>



                      </sequential-entrance>

                        <div class="spacer">
                        </div>


                        <div class="spacer">
                        </div>


                        <div class="spacer">
                        </div>


                        <div class="spacer">
                        </div>



                    </v-container>


      <v-overlay :absolute="absolute" :value="overlay" opacity="0.85">
        <v-btn
          class="mx-2 close-btn"
          fab
          dark
          small
          color="#ccc"
          @click="overlay = false"
          >X</v-btn
        >
        <v-layout row wrap v-if="this.productDetails">
          <v-slide-x-transition>
            <v-flex xs24 sm24 md12 x12>
              <img
                src="@/assets/iphone11.png"
                class="product-animate product"
              />
            </v-flex>
          </v-slide-x-transition>
          <v-flex xs12 sm12 md4 x24>
            <v-list-item class="info-animate mb-margin">
             <v-list-item-content>
                <v-list-item-title class="display-1"
                  >iPhone 11 Pro</v-list-item-title
                >
                <v-list-item-subtitle class="headline"
                  >$ 500</v-list-item-subtitle
                >
                <v-list-item-subtitle class="headline"
                  >Available in Amazon</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="!this.productDetails">
          <v-flex>
            <Bar
              v-if="this.activeDetails.Salesreport"
              class="product-animate detail-card"
            />
            <LineChart
              v-if="this.activeDetails.Leadsreport"
              class="product-animate detail-card"
            />
            <Settings
              v-if="this.activeDetails.Settings"
              class="product-animate detail-card"
            />
            <DecisionTimer
              v-if="this.activeDetails.DecisionTracker"
              class="product-animate detail-card"
            />
            <LineBar
              v-if="this.activeDetails.Profitsreport"
              class="product-animate detail-card"
            />
            <salesProgressBar
              v-if="this.activeDetails.salesProgressBar"
              class="product-animate detail-card"
            />
            <SalesProgressBar
              v-if="this.activeDetails.SalesProgressBar"
              class="product-animate detail-card"
            />
            <ProjectsProgressBar
              v-if="this.activeDetails.ProjectsProgressBar"
              class="product-animate detail-card"
            />
            <AccountingProgressBar
              v-if="this.activeDetails.AccountingProgressBar"
              class="product-animate detail-card"
            />
            <HRProgressBar
              v-if="this.activeDetails.HRProgressBar"
              class="product-animate detail-card"
            />
            <InfrastructureProgressBar
              v-if="this.activeDetails.InfrastructureProgressBar"
              class="product-animate detail-card"
            />
            <Mail
              v-if="this.activeDetails.Email"
              class="product-animate detail-card"
            />
            <Task
              v-if="this.activeDetails.Task"
              class="product-animate detail-card"
            />
            <Calendar
              v-if="this.activeDetails.Calendar"
              class="product-animate detail-card"
            />
            <AppointmentCalendar
              v-if="this.activeDetails.AppointmentCalendar"
              class="product-animate detail-card"
            />
            <Weather
              v-if="this.activeDetails.Weather"
              class="product-animate detail-card"
            />
            <Agenda
              v-if="this.activeDetails.Agenda"
              class="product-animate detail-card"
            />
            <!-- <Search v-if="this.activeDetails.Search" class="product-animate detail-card" /> -->
          </v-flex>
        </v-layout>
      </v-overlay>
    </v-content>
  </vue-page-transition>
</div>
</template>

<script>
import SalesPopup from "@/components/SalesPopup.vue"
import Pipeline from "@/components/Pipeline.vue";
import Quotes from "@/components/Quotes.vue";
import Invoices from "@/components/Invoices.vue";
import SalesGrade from "@/components/SalesGrade.vue";
import SalesInfo from "@/components/SalesInfo.vue";
import Settings from "@/components/Settings.vue";
import Mail from "@/components/Mail.vue";
import Task from "@/components/Task.vue";
import Bar from "@/components/Bar.vue";
import LineBar from "@/components/LineBar.vue";
import LineChart from "@/components/LineChart.vue";
import SalesProgressBar from "@/components/SalesProgressBar.vue";
import ProjectsProgressBar from "@/components/ProjectsProgressBar.vue";
import AccountingProgressBar from "@/components/AccountingProgressBar.vue";
import HRProgressBar from "@/components/HRProgressBar.vue";
import InfrastructureProgressBar from "@/components/InfrastructureProgressBar.vue";
import Agenda from "@/components/Agenda.vue";
import Calendar from "@/components/Calendar.vue";
import AppointmentCalendar from "@/components/AppointmentCalendar.vue";
import Weather from "@/components/Weather.vue";
// import DateLocation from "@/components/DateLocation.vue";
import { gmapApi } from "vue2-google-maps";
// import Search from "@/components/Search.vue";
// import carousel from "vue-owl-carousel";

export default {
  name: "Sales",
  components: {
    Settings,
    Mail,
    Task,
    Bar,
    LineBar,
    LineChart,
    SalesProgressBar,
    ProjectsProgressBar,
    AccountingProgressBar,
    HRProgressBar,
    InfrastructureProgressBar,
    // carousel,
    Calendar,
    AppointmentCalendar,
    // DateLocation,
    Weather,
    Agenda,
    // Search,
    SalesPopup,
    SalesGrade,
    SalesInfo,
    Pipeline,
    Quotes,
    Invoices,
  },
  data() {
    return {
      productDetails: true,
      activeDetails: {
        Email: false,
        Task: false,
        Settings: false,
        Salesreport: false,
        Leadsreport: false,
        Profitsreport: false,
        Calendar: false,
        AppointmentCalendar: false,
        DateLocation: false,
        Weather: false,
        Agenda: false,
        Search: false,
      },
      absolute: true,
      overlay: false,
      title: "",
      google: gmapApi,
      date: new Date().toDateString(),
      position: "",
      icons: [
        { text: "Calendar", icon: "mdi mdi-calendar-today" },
        { text: "Email", icon: "mdi mdi-email" },
        { text: "Salesreport", icon: "mdi mdi-chart-bar" },
        { text: "Task", icon: "mdi mdi-check-outline" },
        { text: "Weather", icon: "mdi mdi-weather-cloudy" },
        { text: "Bank", icon: "mdi mdi-bank" },
      ],
      item: 1,
      selectedItem: 1,
      menu: false,
      userInfo: {},
      salesTracker: [
        {
          label: "DATE",
          message: new Date().toDateString(),
        },
        {
          label: "SALES",
          message: " A total sales of $38,424.15 for this month.",
        },
        {
          label: "PIPELINE",
          message: "A total of $24,754.48 is pending with a high possibility of being closed this week.",
        },
        {
          label: "QUOTES",
          message: "A $210,754.48 total with 109 quotes for the month",
        },
        {
          label: "INVOICES",
          message: "monthly invoices that are a total of $85,175.75 with a total of 29 closed deals for the month.",
        },
      ],
      items: [
        { text: "Home", icon: "mdi-home", nav: "home" },
        { text: "Dashboard", icon: "mdi-view-dashboard", nav: "dashboard" },
        { text: "Agenda", icon: "mdi-view-agenda", nav: "dailyagenda" },
        { text: "Training", icon: "mdi-cube-outline", nav: "training" },
        { text: "Sales", icon: "mdi-account", nav: "salesdepartment" },
        {
          text: "Appointments",
          icon: "mdi-calendar-text",
          nav: "appointments",
        },
        { text: "Forms", icon: "mdi-account-edit", nav: "forms" },
        {
          text: "Sentimental Analysis",
          icon: "mdi-clock",
          nav: "sentimental-analysis",
        },
        { text: "Help", icon: "mdi-help", nav: "help" },
        { text: "Logout", icon: "mdi-flag", nav: "login" },
      ],
    };
  },
  methods: {
    next: () => {
      this.$refs.slick.next();
    },
    prev: () => {
      this.$refs.slick.prev();
    },
    reInit: () => {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.slick.reSlick();
    },
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      speech.text = msg;
      window.speechSynthesis.speak(speech);
    },
    handleAuthClick(event) {
      console.log(event);
      window.gapi.auth2.getAuthInstance().signIn();
    },
    handleSignoutClick(event) {
      console.log(event);
      window.gapi.auth2.getAuthInstance().signOut();
    },
    updateSigninStatus(isSignedIn) {
      if (isSignedIn) {
        //With Google
        console.log("Logged In");
        this.listMessages();
        this.unreadMail();
      } else {
        console.log("Logged out");
      }
    },
    initClient() {
      window.gapi.client
        .init({
          apiKey: "AIzaSyCwSEFovFNJ9L_47CuTBIGGJ4qntTOJmrM",
          clientId:
            "292320827989-nou250q4tjpk0j0h4j5poodgai5km88f.apps.googleusercontent.com",
          discoveryDocs: [
            "https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest",
            "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
          ],
          scope: [
            "https://mail.google.com/",
            "https://www.googleapis.com/auth/calendar.readonly",
          ],
        })
        .then(
          () => {
            window.gapi.auth2
              .getAuthInstance()
              .isSignedIn.listen(this.updateSigninStatus);
            this.updateSigninStatus(
              window.gapi.auth2.getAuthInstance().isSignedIn.get()
            );
          },
          (error) => {
            console.log(error);
          }
        );
    },
    listMessages() {
      window.gapi.client.gmail.users.messages
        .list({
          userId: "me",
        })
        .then(function (response) {
          console.log(response.result);
        });
    },
    unreadMail() {
      window.gapi.client.gmail.users.labels
        .list({
          userId: "me",
        })
        .then(function (response) {
          console.log(response.result);
        });
    },
    nav(path) {
      this.$router.push({ name: path });
    },
    showCard(item) {
      this.selectedItem = 4;
      this.overlay = true;
      this.productDetails = false;
      for (var key in this.activeDetails) {
        // skip loop if the property is from prototype
        if (!this.activeDetails.hasOwnProperty(key)) continue;
        if (key === item) {
          this.title = item;
          this.activeDetails[key] = true;
          console.log(key + " is true");
        } else {
          this.activeDetails[key] = false;
          console.log(key + " is false");
        }
      }
    },
    startsales() {
      for (let i = 1; i < this.salesTracker.length; i++) {
        this.readOutLoud(
          `From ${this.salesTracker[i].label}, you have ${this.salesTracker[i].message}`
        );
      }
    },
  },
  mounted() {
    // console.log(google.client.gmail)
    if (!localStorage.currentUser) {
      this.readOutLoud(`Please Confirm you authentication first`);
      this.$router.push({ name: "login" });
    }
    this.userInfo = JSON.parse(localStorage.getItem("currentUser"));
    // let instance = this;
    // setTimeout(() => {
    var myDate = new Date();
    var hrs = myDate.getHours();
    var greet;
    if (hrs < 12)
      greet =
        "Please say start sales, when you are ready for your department based review.";
    else if (hrs >= 12 && hrs <= 17)
      greet =
        "Please say start sales, when you are ready for your department based review.";
    else if (hrs >= 17 && hrs <= 24)
      greet =
        "Please say start sales, when you are ready for your department based review.";
    this.readOutLoud(`${greet}`);
    window.gapi.load("client:auth2", this.initClient);
    Event.$on("stop", () => {
      this.speech.stop();
    });
    Event.$on("command", (data) => {
      if (!data) return;
      this.overlay = true;
      this.productDetails = false;
      if (
        data.msg.indexOf("emails") !== -1 ||
        data.msg.indexOf("email") !== -1 ||
        data.msg.indexOf("mails") !== -1
      ) {
        this.showCard("Email");
        return;
      } else if (
        data.msg.indexOf("task") !== -1 ||
        data.msg.indexOf("tasks") !== -1
      ) {
        this.showCard("Task");
        return;
      } else if (
        data.msg.indexOf("setting") !== -1 ||
        data.msg.indexOf("settings") !== -1
      ) {
        this.showCard("Settings");
        return;
      } else if (data.msg.indexOf("salesreport") !== -1) {
        this.showCard("SalesReport");
        return;
      } else if (
        data.msg.indexOf("appointment") !== -1 ||
        data.msg.indexOf("appointments") !== -1
      ) {
        this.showCard("AppointmentCalendar");
        return;
      } else if (
        data.msg.indexOf("agenda") !== -1 ||
        data.msg.indexOf("today's agenda") !== -1
      ) {
        this.showCard("Agenda");
        return;
      } else if (data.msg.indexOf("calendar") !== -1) {
        this.showCard("Calendar");
        return;
      }
    });
    Event.$on("showProductDetails", () => {
      console.log("Show Product");
      this.overlay = true;
      this.productDetails = true;
    });
    Event.$on("tasks", (data) => {
      this.salesTracker[2].message = data.events.length + " TASK PENDING";
    });
    Event.$on("startsales", () => {
      this.startsales();
      return;
    });
  },
};
</script>

<style scoped>

.flexbox {
  display: flex;
  justify-content: space-between;

  width: 100%;
  max-width: 1200px;
  height: 440px;

  overflow: hidden;

  margin: 0 auto;
  padding: 0px;

}

.flexbox .board {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  max-width: 100%;
  background-color:transparent;
  padding: 0px;

}

.flexbox .board .card {
  padding: 15px;
  background: rgba(16, 22, 58, 0.3);
  outline-color: #42da91;
  color: #fff;
  min-width: 380px;
  max-width: 40px;
  cursor: pointer;
}
.html, body{
width: 100%;
height: 100%;
padding: 0;
margin: 0;
background-color:#222;
font-size: 0;
}
.svg{
display: block;
width: 100%;
height: 100%;
padding: 0;
margin: 0;
position:absolute;

}
.h1{
width: 100%;
font-family: sans-serif;
position:absolute;
text-align:center;
color:white;
font-size: 18px;
top: 40%;
opacity: 1;
transition: opacity 1s ease-in-out;
-moz-transition: opacity 1s ease-in-out;
-webkit-transition: opacity 1s ease-in-out;
}

.h1 a{
  color: #48b1f4;
  text-decoration:none;
}

.path{
stroke-linecap: square;
stroke: white;
stroke-width: 0.5px;
}

.card {
  height: 100%;
  width: 500px;
  position: relative;
}
.card2 {
  height: 100%;
  width: 500px;
  position: relative;
}
.space {
  height: 20px;
}

.theme-icons {
  background: #10163a;
  color: #fff;
  size: 100px;
}

.theme-icons:hover {
  background: #424242;
  color: #fff;
}

.theme-bg {
  background: rgba(16, 22, 58, 0.3);
  color: #fff;
}

.theme-bg-card {
  background: rgba(16, 22, 58, 0.1);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.30);
}

.theme-bg-card:hover {
  background: rgba(16, 22, 58, 0.5);
  outline-color: #42da91;
  outline-style: solid;
	animation: glow 1800ms ease-out infinite alternate;
	border-color: #393;
	box-shadow: 0 0 5px rgba(0,255,0,.2), inset 0 0 5px rgba(0,255,0,.1), 0 2px 0 #000;
	color: #efe;
	outline-width: 25px;

}

.theme-bg-card-2 {
 background: rgba(48, 64, 87, 0.3);
 outline-color: rgba(90, 128, 191, 0.5);
 outline-style: solid;
 animation: glow 1800ms ease-out infinite alternate;
 border-color: #5a80bf;
 box-shadow: 0 0 5px rgba(90,128,191,.4), inset 0 0 10px rgba(90,128,191,.2), 0 4px 0 #000;
 color: #efe;
 outline-width: 2px;
}

.theme-bg-card-2:hover {
  background: rgba(48, 64, 87, 0.6);
  outline-color: rgba(90, 128, 191, 0.7);
  outline-style: solid;
	animation: glow 1800ms ease-out infinite alternate;
	border-color: #5a80bf;
	box-shadow: 0 0 10px rgba(90,128,191,.6), inset 0 0 15px rgba(90,128,191,.4), 0 6px 0 #000;
	color: #efe;
  outline-width: 3px;
}

.theme-bg-card-3 {
  color: #fff;
  background: rgba(66, 218, 145, 0.6);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.30);

}

.theme-bg-card-3:hover {
  background: rgba(66, 218, 145, 0.8);
  outline-color: #42da91;
  outline-style: solid;
	animation: glow 1800ms ease-out infinite alternate;
	border-color: #393;
	box-shadow: 0 0 5px rgba(0,255,0,.2), inset 0 0 5px rgba(0,255,0,.1), 0 2px 0 #000;
	color: #efe;
	outline: none;
}



.theme-bg-card-warning {
  background: rgba(255, 255, 0, 0.3);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.30);
}

.theme-bg-card-warning:hover {
  background: rgba(255, 255, 0, 0.5);
  outline-color: #42da91;
  outline-style: solid;
	animation: glow 1800ms ease-out infinite alternate;
	border-color: #393;
	box-shadow: 0 0 5px rgba(0,255,0,.2), inset 0 0 5px rgba(0,255,0,.1), 0 2px 0 #000;
	color: #efe;
	outline: none;

}

.theme-bg-card-negative {
  background: rgba(255, 0, 0, 0.3);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.30);
}

.theme-bg-card-negative:hover {
  background: rgba(255, 0, 0, 0.5);
  outline-color: #FF0000;
  outline-style: solid;
	animation: glow 1800ms ease-out infinite alternate;
	border-color: #FF0000;
	box-shadow: 0 0 5px rgba(255,0,0,.2), inset 0 0 5px rgba(255,0,0,.1), 0 2px 0 #000;
	color: #efe;
	outline: none;

}

@keyframes glow {
    0% {
		border-color: #11ece5;
		box-shadow: 0 0 5px rgba(90,128,191,.2), inset 0 0 6px rgba(90,128,191,.1), 0 4px 0 #000;
    }

    100% {
		border-color: #11ece5;
		box-shadow: 0 0 8px rgba(90,128,191,.8), inset 0 0 10px rgba(90,128,191,.4), 0 2px 0 #000;
    }
}


.theme-bg-card-lg {
  background: rgba(16, 22, 58, 0.3);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.30);
}


.theme-bg-card-lg:hover {
  background: rgba(16, 22, 58, 0.5);
  outline-color: #42da91;
  outline-style: solid;
	animation: glow 1000ms ease-out infinite alternate;
	border-color: #393;
	box-shadow: 0 0 7px rgba(0,255,0,.2), inset 0 0 7px rgba(0,255,0,.1), 0 2px 0 #000;
	outline: none;

}


@keyframes glow {
    0% {
		border-color: #11ece5;
		box-shadow: 0 0 7px rgba(90,128,191,.2), inset 0 0 7px rgba(90,128,191,.1), 0 2px 0 #000;
    }
    100% {
		border-color: #78b59c;
		box-shadow: 0 0 10px rgba(90,128,191,.8), inset 0 0 12px rgba(90,128,191,.4), 0 2px 0 #000;
    }
}




.space1 {
  height: 35px;
}

.space2 {
  height: 5px;
}

.space3 {
  height: 1px;
}

.space4 {
  height: 2px;
}
.space5 {
  height: 0px;
}
.space6 {
  height: 20px;
}
.space7 {
  height: 0px;
}


.tabbar {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    align-items: center;
    & > li {
        margin: 0 11px;
        & > svg {
            width: 14px;
            height: 14px;
            display: block;
            fill: #2F3545;
            transition: opacity .3s ease;
        }
    }
    &.open {
        & > li {
            & > svg {
                opacity: .5;
            }
        }
    }
}

.Center & dribbble
body {
    min-height: 90vh;
    font-family: Roboto, Arial;
    color: #ADAFB6;
    background: #171C28;
    display: flex;
    justify-content: center;
    align-items: center;
    .dribbble {
        position: fixed;
        display: block;
        right: 20px;
        bottom: 20px;
        img {
            display: block;
            height: 28px;
        }
    }
}

.text-color-2 {
  color: #42da91 !important;
}

.user-ui {
  background: rgba(48, 64, 87, 1);
  opacity: 1;
  color: #fff;
  padding: 20px;
}

.theme-bg-2 {
  background: rgba(16, 22, 58, 0.3);
  color: #fff;
}
.menu-icon {
  background: rgba(16, 22, 58, 0.3);
  padding: 30px;
  display: inline-block;
  margin-left: 50px;
  /* margin-top: 20px; */
  text-align: center;
  cursor: pointer;
}
.menu-icon:hover {
  background: rgba(16, 22, 58, 0.5);
  padding: 30px;
  display: inline-block;
  margin-left: 50px;
  /* margin-top: 20px; */
  text-align: center;
  cursor: pointer;
}
.close-btn {
  position: absolute;
  right: 0px;
  margin-top: -60px;
}
.btn{
  outline: none !important;
}
.btn.btn-primary {
  background-color: $purple;
  border-color: $purple;
  outline: none;
  &:hover {
    background-color: darken($purple, 10%);
    border-color: darken($purple, 10%);
  }
  &:active, &:focus {
    background-color: lighten($purple, 5%);
    border-color: lighten($purple, 5%);
  }
  & .fa {
    padding-right: 4px;
  }
}

.icons {
  font-size: 40px;
  color: #fff;
  margin-top: 0px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 10px;
  text-align: center;
  color: #42da91 !important;
}
.icons:hover {
  font-size: 40px;
  color: #fff;
  margin-top: 0px;
  position: absolute;
  padding: 0px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  color: #ffffff !important;
}
.detail-card {
  width: 800px;
  height: 400px;
  background: #09435f;
  opacity: .75;
  position: absolute;
}
.db-content {
  background: linear-gradient(-45deg, #0f1724, #151f2f, #19253a, #304057);
	background-size: 400% 400%;
  min-height: 100vh;
	-webkit-animation: gradient 25s ease infinite;
	-animation: gradient 25s ease infinite;
}

@-webkit-keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}

@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
  height: 150%;
}

.mobile-view {
  display: none;
}
.desktop-view {
  display: block;
}
.three-dot {
  margin-top: 10px;
  float: right;
  color: #fff;
}
.product-animate {
  animation-name: slideleft;
  position: relative;
  position-fromTop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeIn;
}
.product-animate-out {
  animation-name: slideright;
  position: relative;
  position-fromTop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeOut;
}
.info-animate {
  animation-name: slideleft;
  position: relative;
  position-fromTop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeIn;

}
.info-animate-out {
  animation-name: slideright;
  position: relative;
  position-fromTop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeOut;
}
.product {
  width: 400px;
}
/* Standard syntax */
@keyframes slideleft {
  0% {
    left: -800px;
    top: 0px;
  }
  100% {
    left: 10px;
    top: 0px;
  }
}
/* Standard syntax */
@keyframes slideright {
  0% {
    left: 800px;
    top: 0px;
  }
  100% {
    left: 0px;
    top: 0px;
  }
}
@media only screen and (max-width: 600px) {
  .product {
    width: 90%;
  }
  .card-margin {
    margin-top: 40px;
  }
  .mobile-view {
    display: block;
  }
  .desktop-view {
    display: none;
  }
  .db-content {
    height: 100%;
  }
  .menu-icon-2 {
    margin-left: 20px;
    color: #42da91 !important;
    margin-top: 20px;
  }
  .mb-margin {
    text-align: center;
  }
  .detail-card {
    width: 350px;
    height: 100%;
  }
  .text-color {
    color: #fff !important;
  }
  .container {
    padding: 15px;
  }
  * {
    margin: 0;
    padding: 0;
    outline: none;
  }

  .panel img {
    width: 100px;
  }

  div.widget {
    padding: 3px;
    padding-right: 30px;
  }

  div.date {
    font-size: 14px;
    font-weight: bold;
    color: fff;
  }

  div.temp {
    font-size: 81px;
    color: rgba(0, 0, 0, 0.9);
    font-weight: 100;
  }

  div.panel {
    display: inline-block;
  }

  div.right-panel {
    position: absolute;
    right: 50px;
    top: 0;
    margin-top: 35px;
    padding-left: 10px;
 }

}
</style>
